import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaPlusCircle, FaHome, FaKey, FaListUl, FaBuilding } from 'react-icons/fa';

const linkClass = ({ isActive }) =>
  [
    'flex min-h-11 items-center gap-[0.75rem] rounded-lg px-[1rem] py-[0.75rem] text-[15px] font-semibold transition-colors',
    isActive ? 'bg-[#1A1A1A] text-[#EEC24B] border border-[#EEC24B]/30' : 'text-white hover:bg-[#141414] hover:text-[#EEC24B]',
  ].join(' ');

const AdminSidebar = () => {
  return (
    <aside className="flex h-auto w-full flex-col gap-3 border-b border-[#262626] bg-[#0B0B0B] p-3 lg:sticky lg:top-0 lg:h-screen lg:w-[280px] lg:border-b-0 lg:border-r lg:p-4">
      <div className="rounded-[18px] border border-[#262626] bg-[#111] p-[1rem]">
        <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-[#999]">Millennium Realty</p>
        <h2 className="mt-[0.35rem] text-[22px] font-bold text-white">Admin Panel</h2>
      </div>

      <nav className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:flex lg:flex-col lg:gap-2">
        <NavLink to="/admin" end className={linkClass}>
          <FaHome />
          Dashboard
        </NavLink>
        <NavLink to="/admin/create" className={linkClass}>
          <FaPlusCircle />
          Create Listing
        </NavLink>
        <NavLink to="/admin/rent" className={linkClass}>
          <FaListUl />
          Rent / Lease
        </NavLink>
        <NavLink to="/admin/property-listing" className={linkClass}>
          <FaBuilding />
          Property Listing
        </NavLink>
        <NavLink to="/admin/settings" className={linkClass}>
          <FaKey />
          Settings
        </NavLink>
      </nav>
    </aside>
  );
};

export default AdminSidebar;
